import {proxyBE} from './common';

export const qrCodeService = {  
    
    action(data) {
        return proxyBE.post(`qrcode/action`, {data});
    },
}